<!--[if IE]>
    <p class="unsupported">You are using an unsupported browser, so some parts of this page may not display or work as intended. Visit <a href="https://browsehappy.com/">browsehappy.com</a> to upgrade your browser.</p>
<![endif]-->
  <header class="page-header">
    <!--stickyHeader
    (onDirectionEvent)="directionChanged($event)"
    [customDirectionHandler]="directionHandler$"
    [class.is-inactive]="!showHeader"-->

    <nav class="navbar">
      <div class="container-fluid">
        <h1 class="brand">
          <img src="/assets/logo.png">
          <span class="sr-only">cap hpi</span>
          <span class="title-text">
            <span class="visible-md visible-lg">residual value tracker</span>
          </span>
        </h1>

        <!-- Mobile Version -->
        <div class="navbar-header">
          <!-- visible xs : navbar-toggle @media (min-width: 768px) -->

          <ul class="nav navbar-nav navbar-right navbar-toggle_old visible-xs"
              *ngIf="useIdentityServer">
            <li class="dropdown" dropdown>
              <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle>
                <!--<img src="https://{{ bootstrapBaseUri }}/v3.0.0/img/user.png" width="35" aria-hidden="true">-->
                <img src="//bootstrap.cap-hpi.com/v2.0.0/img/user.png" width="24" aria-hidden="true">
              </a>
              <ul class="dropdown-menu dropdown-arrow-right" *dropdownMenu>
                <li *ngIf="!isLoggedIn">
                  <a (click)="login()" class="pointer">Sign In</a>
                </li>
                <li *ngIf="isLoggedIn">
                  <a (click)="logout()" class="pointer">Sign Out</a>
                </li>
              </ul>
            </li>
          </ul>

          <button type="button" class="navbar-toggle"
                  [ngClass]="{'navbar-toggle--opened': isCollapsed}"
                  (click)="isCollapsed = !isCollapsed">
            <!--<span class="sr-only">Toggle navigation</span>-->
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <!--<a href="#" class="navbar-brand visible-xs">Brand/Logo</a>-->
        </div>
        <div class="visible-xs"
             *ngIf="isCollapsed">
          <div class="text-primary" style="padding: 10px; background-color: #000">residual value tracker</div>

          <!--<lud-settings-filter class="mobile-filters"
                               *ngIf="(useIdentityServer && isLoggedIn) || !useIdentityServer"></lud-settings-filter>-->

        </div>


        <!-- Desktop Version -->
        <!--<div class="hidden-xs">
          <lud-settings-filter *ngIf="(useIdentityServer && isLoggedIn) || !useIdentityServer"></lud-settings-filter>
        </div>-->
        <ul class="nav navbar-nav navbar-right hidden-xs"
            *ngIf="useIdentityServer">
          <li class="dropdown" dropdown>
            <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle>
              <!--<img src="https://{{ bootstrapBaseUri }}/v3.0.0/img/user.png" width="35" aria-hidden="true">-->
              <img src="//bootstrap.cap-hpi.com/v2.0.0/img/user.png" width="24" aria-hidden="true">
            </a>
            <ul class="dropdown-menu dropdown-arrow-right" *dropdownMenu>
              <li *ngIf="!isLoggedIn">
                <a (click)="login()" class="pointer">LogIn</a>
              </li>
              <li *ngIf="isLoggedIn">
                <a (click)="logout()" class="pointer">LogOut</a>
              </li>
            </ul>
          </li>
        </ul>

        <!--<ul class="nav navbar-nav navbar-right">
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
            <img src="//bootstrap.cap-hpi.com/v2.0.0/img/user.png" width="24" aria-hidden="true">
            <i class="fa fa-angle-down text-primary pl-2 hidden-sm-down" aria-hidden="true"></i>
          </a>
          <ul class="dropdown-menu dropdown-arrow-right">
            <li>
              <a href="#">My Profile</a>
            </li>
            <li>
              <a href="#">Editorial</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <a href="#">Terms &amp; Conditions</a>
            </li>
            <li role="separator" class="divider"></li>
            <li>
              <a href="#">Log Out</a>
            </li>
          </ul>
        </li>
      </ul>-->


      </div>
    </nav>
  </header>

<div class="black-overlay"
     [ngClass]="{'black-overlay--opened': isCollapsed}"></div>
